import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSelectedUsersInfoStatus = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.selectedUsersInfoStatus],
  (data) => data
);
